(function () {
  'use strict';
  window.FOMO = window.FOMO || {};

  // ---------- navigation ----------
  function initNav() {
    var nav = document.querySelector('.navbar');
    if (!nav) return;
    var btn = nav.querySelector('.mobile-menu-btn');
    var panel = document.getElementById('mobile-nav-panel');
    var links = nav.querySelector('.nav-links');
    if (btn) {
      btn.addEventListener('click', function () {
        btn.classList.toggle('active');
        if (panel) panel.classList.toggle('open');
        if (links) links.classList.toggle('open');
        document.body.classList.toggle('menu-open');
      });
    }
    if (!nav.classList.contains('always-scrolled')) {
      var onScroll = function () { nav.classList.toggle('scrolled', window.scrollY > 80); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        if (id.length < 2) return;
        var target = document.querySelector(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  // ---------- cart ----------
  // Formats cents with the store's shop.money_format (window.FOMO_MONEY_FORMAT, set in theme.liquid).
  // HTML tags in the format (e.g. <span class=money>) are stripped: the result is plain text.
  function formatMoneyWith(cents, format) {
    function fmt(n, precision, thousands, decimal) {
      var parts = (Number(n) / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    var fmtStr = String(format || '\u20b9{{amount_no_decimals}}').replace(/<[^>]*>/g, '');
    return fmtStr.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount': return fmt(cents, 2, ',', '.');
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        default: return fmt(cents, 2, ',', '.');
      }
    });
  }
  window.FOMO.formatMoney = function (cents) { return formatMoneyWith(cents, window.FOMO_MONEY_FORMAT); };

  function q(sel, root) { return (root || document).querySelector(sel); }

  function renderCart(cart) {
    var items = q('[data-cart-items]');
    var empty = q('[data-cart-empty]');
    var footer = q('[data-cart-footer]');
    var count = q('[data-cart-count]');
    if (count) { count.textContent = cart.item_count; count.hidden = !(cart.item_count > 0); }
    if (!items || isCartPage()) return; // /cart rows are server-rendered (cart-main)
    items.innerHTML = cart.items.map(function (it) {
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? ' <span class="cart-item-variant">— ' + escapeHtml(it.variant_title) + '</span>' : '';
      var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2') + '" alt="" width="80" height="80" loading="lazy">' : '';
      return '<div class="cart-item" data-line-key="' + escapeHtml(it.key) + '" data-qty="' + Number(it.quantity) + '">' +
        '<div class="cart-item-image">' + img + '</div>' +
        '<div class="cart-item-details">' +
          '<div class="cart-item-title">' + escapeHtml(it.product_title) + variant + '</div>' +
          '<div class="cart-item-price">' + escapeHtml(window.FOMO.formatMoney(it.final_line_price)) + '</div>' +
          '<div class="cart-item-controls">' +
            '<button type="button" class="qty-btn" data-qty-change="-1" aria-label="Decrease">−</button>' +
            '<span class="qty-value">' + it.quantity + '</span>' +
            '<button type="button" class="qty-btn" data-qty-change="1" aria-label="Increase">+</button>' +
            '<button type="button" class="qty-btn cart-item-remove" data-qty-change="remove" aria-label="Remove">×</button>' +
          '</div></div></div>';
    }).join('');
    var has = cart.item_count > 0;
    if (empty) empty.hidden = has;
    if (footer) footer.hidden = !has;
    var sub = q('[data-cart-subtotal]');
    if (sub) sub.textContent = window.FOMO.formatMoney(cart.total_price);
  }

  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function showCartError(msg) { var el = q('[data-cart-error]'); if (el) { el.textContent = msg; el.hidden = !msg; } }

  window.FOMO.refreshCart = function () {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  };

  // The drawer is inert while closed (also set in Liquid); opening focuses the close button and
  // closing returns focus to whatever opened it.
  var cartOpener = null;
  window.FOMO.openCart = function () {
    var d = q('.cart-drawer'), b = q('.cart-backdrop');
    if (!d) return;
    if (!d.classList.contains('active')) cartOpener = document.activeElement;
    d.inert = false; d.removeAttribute('inert');
    d.classList.add('active'); d.setAttribute('aria-hidden', 'false');
    if (b) b.classList.add('active');
    document.body.classList.add('cart-open');
    var close = q('.cart-close', d);
    if (close) close.focus();
  };
  window.FOMO.closeCart = function () {
    var d = q('.cart-drawer'), b = q('.cart-backdrop');
    if (!d) return;
    var wasOpen = d.classList.contains('active');
    d.classList.remove('active'); d.setAttribute('aria-hidden', 'true');
    d.inert = true; d.setAttribute('inert', '');
    if (b) b.classList.remove('active');
    document.body.classList.remove('cart-open');
    if (wasOpen && cartOpener && typeof cartOpener.focus === 'function' && document.contains(cartOpener)) cartOpener.focus();
    if (wasOpen) cartOpener = null;
  };
  // legacy globals used by ported inline handlers
  window.openCart = window.FOMO.openCart;
  window.closeCart = window.FOMO.closeCart;

  window.FOMO.addToCart = function (variantId, quantity) {
    showCartError('');
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity) || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); });
      return r.json();
    }).then(function () {
      if (typeof gtag === 'function') gtag('event', 'add_to_cart', { item_id: String(variantId), quantity: Number(quantity) || 1 });
      return window.FOMO.refreshCart();
    }).then(function (cart) { window.FOMO.openCart(); return cart; })
      .catch(function (e) { showCartError(e.message); window.FOMO.openCart(); throw e; });
  };

  // On /cart the server-rendered form (cart-main) is the source of truth: after a change the page reloads
  // instead of re-rendering rows client-side.
  function isCartPage() { return !!q('[data-section="cart-main"]'); }

  // Resolves with the cart on success, or null on failure (the error is shown; it never rejects).
  window.FOMO.changeLine = function (key, quantity) {
    showCartError('');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { if (!r.ok) throw new Error('Could not update cart'); return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function (e) { showCartError(e.message); return null; });
  };

  var linesInFlight = new Set();
  function setRowBusy(row, key, busy) {
    if (busy) { linesInFlight.add(key); row.setAttribute('aria-busy', 'true'); }
    else { linesInFlight.delete(key); row.removeAttribute('aria-busy'); }
    row.querySelectorAll('.qty-btn').forEach(function (b) { b.disabled = busy; });
  }

  window.FOMO.initCart = function () {
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-cart-open], [data-cart-close], [data-qty-change], [data-checkout]');
      if (!t) return;
      if (t.hasAttribute('data-cart-open')) { e.preventDefault(); window.FOMO.openCart(); }
      else if (t.hasAttribute('data-cart-close')) { if (t.tagName !== 'A') e.preventDefault(); window.FOMO.closeCart(); }
      else if (t.hasAttribute('data-qty-change')) {
        var row = t.closest('[data-line-key]');
        if (!row) return;
        var key = row.getAttribute('data-line-key');
        if (linesInFlight.has(key)) return; // ignore clicks while this line's change is pending
        var current = Number(row.getAttribute('data-qty')) || 0;
        var change = t.getAttribute('data-qty-change');
        var next = change === 'remove' ? 0 : Math.max(0, current + Number(change));
        setRowBusy(row, key, true);
        // changeLine never rejects (it catches and shows the error). In the drawer renderCart replaces the row on
        // success; on /cart the page reloads. On failure the same row stays in the DOM and is re-enabled here.
        window.FOMO.changeLine(key, next).then(function (cart) {
          if (cart && isCartPage()) { window.location.reload(); return; }
          setRowBusy(row, key, false);
        });
      } else if (t.hasAttribute('data-checkout')) {
        if (typeof gtag === 'function') gtag('event', 'begin_checkout');
      }
    });
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('form[data-ajax-add]')) return;
      e.preventDefault();
      var id = form.querySelector('[name="id"]').value;
      var qtyEl = form.querySelector('[name="quantity"]');
      var btn = form.querySelector('[type="submit"]');
      if (btn && (btn.disabled || btn.dataset.soldOut)) return;
      if (btn) btn.disabled = true;
      window.FOMO.addToCart(id, qtyEl ? qtyEl.value : 1).catch(function () {}).then(function () { if (btn) btn.disabled = !!btn.dataset.soldOut; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var d = q('.cart-drawer');
      if (d && d.classList.contains('active')) window.FOMO.closeCart();
    });
  };

  // ---- Generic animations (ported from src/lib/ui.js initAnimations) ----
  function initReveal() {
    var items = document.querySelectorAll('.reveal-item');
    if (!items.length) return;
    items.forEach(function (item) {
      gsap.set(item, { opacity: 0, y: 30 });
      ScrollTrigger.create({
        trigger: item,
        start: 'top 90%',
        once: true,
        onEnter: function () {
          gsap.to(item, { opacity: 1, y: 0, duration: 0.6, ease: 'power2.out', delay: parseFloat(item.dataset.delay) || 0 });
          item.classList.add('is-visible');
        }
      });
    });
    setTimeout(function () {
      items.forEach(function (item) {
        if (window.getComputedStyle(item).opacity === '0') gsap.to(item, { opacity: 1, y: 0, duration: 0.5 });
      });
    }, 3000);
  }

  function initParallax() {
    document.querySelectorAll('[data-parallax-container] [data-parallax]').forEach(function (el) {
      var speed = parseFloat(el.dataset.parallax) || 0.1;
      gsap.to(el, {
        yPercent: -30 * speed,
        ease: 'none',
        scrollTrigger: { trigger: el.closest('[data-parallax-container]'), start: 'top bottom', end: 'bottom top', scrub: true }
      });
    });
  }

  function initHeroFade() {
    ['.hero-content', '.craft-hero-content', '.indulge-hero-content'].forEach(function (sel) {
      var target = document.querySelector(sel);
      if (target && target.children.length) {
        gsap.from(target.children, { opacity: 0, y: 40, stagger: 0.15, duration: 0.8, ease: 'power2.out', delay: 0.3 });
      }
    });
  }

  function initScrollIndicator() {
    // page-home.js owns the indicator on the home hero
    if (document.querySelector('.hero-center-content')) return;
    var indicator = document.querySelector('.scroll-indicator');
    if (!indicator) return;
    ScrollTrigger.create({
      start: 'top -100',
      onEnter: function () { gsap.to(indicator, { opacity: 0 }); },
      onLeaveBack: function () { gsap.to(indicator, { opacity: 1 }); }
    });
  }

  function initTestimonials() {
    document.querySelectorAll('.testimonial-card').forEach(function (card, index) {
      gsap.set(card, { opacity: 0, y: 30 });
      ScrollTrigger.create({
        trigger: card,
        start: 'top 85%',
        once: true,
        onEnter: function () { gsap.to(card, { opacity: 1, y: 0, duration: 0.6, delay: index * 0.15, ease: 'power2.out' }); }
      });
    });
  }

  function initCardHover() {
    document.querySelectorAll('.product-card, .gift-card, .persona-card').forEach(function (card) {
      card.addEventListener('mouseenter', function () { gsap.to(card, { y: -6, duration: 0.3, ease: 'power2.out' }); });
      card.addEventListener('mouseleave', function () { gsap.to(card, { y: 0, duration: 0.3, ease: 'power2.out' }); });
    });
  }

  function initBackToTop() {
    var btn = document.querySelector('.footer-back-to-top');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  window.FOMO.initAnimations = function () {
    initBackToTop();
    if (!window.gsap || !window.ScrollTrigger) {
      // No animation library: show reveal items immediately (theme.css .reveal-item.revealed).
      document.querySelectorAll('.reveal-item').forEach(function (el) { el.classList.add('revealed'); });
      return;
    }
    gsap.registerPlugin(ScrollTrigger);
    initReveal();
    initParallax();
    initHeroFade();
    initScrollIndicator();
    initTestimonials();
    initCardHover();
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { ScrollTrigger.refresh(); }, 250);
    });
    setTimeout(function () { ScrollTrigger.refresh(); }, 500);
  };

  document.addEventListener('DOMContentLoaded', function () {
    initNav();
    if (window.FOMO.initCart) window.FOMO.initCart();
    if (window.FOMO.initAnimations) window.FOMO.initAnimations();
  });
})();
